import React, { useState } from "react";
import { Table, Input, Button, message, Modal } from "antd";

const { TextArea } = Input;

interface TableColumn {
    title: string;
    dataIndex: string;
    key: string;
    width?: number;
    ellipsis?: boolean;
    render?: (text: any, record: any) => React.ReactNode;
}

interface BulkExcelPasteTableProps {
    modelFields: TableColumn[];
    isVisible: boolean;
    onClose: () => void;
    onSubmit: (data: any[]) => void;
}

const BulkExcelPasteTable: React.FC<BulkExcelPasteTableProps> = ({
    modelFields,
    isVisible,
    onClose,
    onSubmit
}) => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [columns, setColumns] = useState<TableColumn[]>([]);
    const [rawInput, setRawInput] = useState("");

    const getModelFields = (fields: TableColumn[]): TableColumn[] => {
        return fields.filter(col => col.title !== '').map(col => ({
            ...col,
            ellipsis: true
        }));
    };

    const handlePasteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setRawInput(value);

        const rows = value.trim().split("\n").filter(Boolean);
        const parsedRows = rows.map(row => row.split("\t"));

        if (!parsedRows.length) return;

        const validCols = getModelFields(modelFields)
            .filter(field => field.dataIndex !== "id" && field.key !== "id");
        setColumns(validCols);

        const formattedData = parsedRows.map(cols => {
            const rowObj = Object.create(null);
            validCols.forEach((field, colIndex) => {
                rowObj[field.dataIndex] = cols[colIndex] ?? "";
            });
            return rowObj;
        });

        setTableData(formattedData);
    };

    const handleSave = () => {
        if (!tableData.length) {
            message.warning("Gönderilecek veri yok!");
            return;
        }

        onSubmit(tableData);
        handleCancel();
    };

    const handleCancel = () => {
        setTableData([]);
        setRawInput("");
        onClose();
    };

    return (
        <Modal
            title="Toplu Veri Yükleme"
            open={isVisible}
            onCancel={handleCancel}
            width={1000}
            footer={null}
        >
            <div>
                <TextArea
                    value={rawInput}
                    onChange={handlePasteChange}
                    rows={6}
                    placeholder="Excel'den kopyaladığınız veriyi buraya yapıştırın"
                />
                <br />
                {tableData.length > 0 && (
                    <>
                        <div className="flex sticky top-0 bg-white z-10 py-2 opacity-80">
                            <Button type="primary" onClick={handleSave}>
                                Kaydet ve API'ye Gönder
                            </Button>
                            <Button
                                type="primary"
                                danger
                                onClick={() => {
                                    setTableData([]);
                                    setRawInput("");
                                }}
                                style={{ marginLeft: 8 }}
                            >
                                Temizle
                            </Button>
                        </div>
                        <Table
                            columns={columns}
                            dataSource={tableData}
                            pagination={false}
                            bordered
                            size="middle"
                        />
                    </>
                )}
            </div>
        </Modal>
    );
};

export default BulkExcelPasteTable;
